import { render, staticRenderFns } from "./userInformation.vue?vue&type=template&id=5640621d&scoped=true"
import script from "./userInformation.vue?vue&type=script&lang=js"
export * from "./userInformation.vue?vue&type=script&lang=js"
import style0 from "./userInformation.vue?vue&type=style&index=0&id=5640621d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640621d",
  null
  
)

export default component.exports